import { useEffect } from 'react';
import { getCollabSocket, joinRoom, leaveRoom } from '../api/collab.js';

/**
 * Subscribe to a Socket.IO room and listen for one or more events.
 *
 * @param {Object}   opts
 * @param {string}   opts.type   – room type, e.g. "issue"
 * @param {string}   opts.id     – resource id
 * @param {Object}   opts.events – { eventName: (payload) => void }
 */
export function useRealtime({ type, id, events = {} }) {
  useEffect(() => {
    const sock = getCollabSocket();
    if (!sock || !type || !id) return;
    joinRoom(type, id);
    const handlers = {};
    for (const [name, fn] of Object.entries(events)) {
      handlers[name] = fn;
      sock.on(name, fn);
    }
    return () => {
      for (const [name, fn] of Object.entries(handlers)) sock.off(name, fn);
      leaveRoom(type, id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id, JSON.stringify(Object.keys(events))]);
}
